'use strict';

/* Constants for working with Products. */

exports.ItemTypes = {
	Book: 'book',
	DVD: 'dvd',
	Event: 'event',
	Pilgrimage: 'pilgrimage',
	Roasry: 'rosary',
	Merchandise: 'merchandise',
	Bundled: 'bundled',
	Donation: 'donation'
};

exports.DonationClasses = {
	OneTime: 'DON-USA-OTG',
	Monthly: 'DON-USA-RGM',
	Annual: 'DON-USA-RGA'
};

exports.ProductBadges = {
	Sale: 'sale',
	New: 'new',
	Free: 'free',
	Preorder: 'preorder',
	Bestseller: 'bestseller',
	Outofstock: 'outofstock',
	Backinstock: 'backinstock',
	Almostgone: 'almostgone'
};

exports.DefaultDonationFrequencies = {
	Single: 'DON-USA-OTG-25',
	Monthly: 'DON-USA-RGM-25',
	Annual: 'DON-USA-RGA-300'
};
